import type { CallToActionModel } from '~~/app/models'
import { usePageUrls } from './usePageUrls'

export const useCtaLink = async (cta: CallToActionModel): Promise<string> => {
  const email = ref(cta?.elements?.email_address?.value)
  const phone = ref(cta?.elements?.phone_number?.value)
  const genericAsset = ref(cta?.elements?.generic_asset_target?.value)
  const linkedTarget = ref(cta?.elements?.linked_target?.value)
  const manualTarget = ref(stripHtmlTags(cta?.elements?.manual_target?.value))
  if (linkedTarget?.value?.length > 0) {
    const codename = linkedTarget.value[0]!
    const { getUrlByCodename } = usePageUrls()
    return await getUrlByCodename(codename)
  } else if (genericAsset?.value?.length > 0) {
    return genericAsset.value[0]!.url
  } else if (manualTarget?.value?.length > 0) {
    return manualTarget.value
  } else if (email?.value?.length > 0) {
    return `mailto:${email.value}`
  } else if (phone?.value?.length > 0) {
    return `tel:${phone.value}`
  }
  return ''
}
